import { useEffect } from 'react';

import { Login } from '../../access/Login';
import { Who } from '../../access/Who';
import { useSession } from '../../access/session';
import { appHref } from '../route';
import { applyPhoneFlag } from './detect';
import './phone.css';

export function PhoneLanding(): React.ReactElement {
  const known = useSession((s) => s.known);
  const authenticated = useSession((s) => s.me.authenticated);
  const access = useSession((s) => s.me.access);
  const inside = Boolean(known && authenticated && access);

  useEffect(() => {
    applyPhoneFlag();
    document.body.classList.add('nx-body');
    void useSession.getState().load();
    return () => document.body.classList.remove('nx-body');
  }, []);

  return (
    <div className="ph-land">
      <header className="ph-land__top">
        <span>FORQ</span>
        <Who />
      </header>
      <h1>вход</h1>
      <p>лента прематча на телефоне. тот же аккаунт, что за столом.</p>
      {known &&
        (inside ? (
          <a className="ph-land__go" href="/app/prematch">
            открыть прематч
          </a>
        ) : authenticated ? (
          <p>нужно приглашение — напишите в Telegram тому, кто вас зовёт.</p>
        ) : (
          <div className="ph-land__tg">
            <Login onDone={() => location.assign('/app/prematch')} />
          </div>
        ))}
      {!known && <p>проверяем сессию…</p>}
      {!inside && known && (
        <a className="ph-land__quiet" href={appHref()}>
          всё равно на ленту
        </a>
      )}
    </div>
  );
}
